module.exports = __webpack_public_path__ + "static/media/image_62.205dd914.png";